import { apiUrl } from 'src/config';
import { safeLocalStorage } from 'src/utils/local-storage';

const QR_SCAN_SENT_KEY_PREFIX = 'pvo.qr_scan.sent.';
export const START_RECORDING_SENT_KEY_PREFIX = 'pvo.start_recording.sent.';

export const notifyQRCodeScanned = async (hash: string) => {
  try {
    safeLocalStorage.setItem(`${QR_SCAN_SENT_KEY_PREFIX}${hash}`, 'true');
    const response = await fetch(`${apiUrl}/v2/pvo/qr-scanned/${hash}`, {
      method: 'POST',
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
  } catch (error) {
    console.error('[PVO] Failed to notify QR scan:', error);
  }
};

export const markStartRecordingSent = (hash: string) => {
  safeLocalStorage.setItem(`${START_RECORDING_SENT_KEY_PREFIX}${hash}`, 'true');
};
